export default "__VITE_ASSET__DgdSJtZ1__"